// extracted by mini-css-extract-plugin
export default {"spinner_card":"loadingSpinner_spinner_card__UTdum","spinner":"loadingSpinner_spinner__7uqMV","spin":"loadingSpinner_spin__Askiy"};